export default function LightProfileProto() {
    this.userId = 0;
    this.conversationId = 0;

    //for navigation
    this.userIndex = 0;
    this.users = [];

    this.screen = 'main';
    this.decryptedProfilePicture = null
}
